import { Flex, Text } from "@chakra-ui/react";
import { IconSpeed, IconSpeedStats } from "icons";

interface MetricsTagProps {
  backgroundColor: string;
  borderColor: string;
  icon: React.ReactNode;
  color: string;
  text: string;
}

const MetricsTag = ({ backgroundColor, borderColor, icon, text, color }: MetricsTagProps) => {
  return (
    <Flex
      background={backgroundColor}
      borderRightRadius="4px"
      p="1.5"
      alignItems="center"
      justifyContent="center"
      w="fit-content"
      gap="1"
      position="relative"
      _before={{
        content: '""',
        position: 'absolute',
        inset: 0,
        borderRadius: '4px',
        background: {borderColor},
        padding: '2px',
        paddingLeft: '0px',
        mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        maskComposite: 'exclude',
      }}
    >
      <Text
        fontSize={{ base: '0.75rem', md: '0.875rem' }}
        lineHeight={{ base: '0.875rem', md: '1.125rem' }}
        fontWeight="500"
        color={color}
      >
        {text}
      </Text>
      {icon}
    </Flex>
  );
};

export default MetricsTag;